// Admin Orders translations
export const adminOrdersTranslations = {
    en: {
        // Page header
        orders: "Orders",
        viewAndManageOrders: "View and manage customer orders",

        // Action buttons
        bulkActions: "Bulk Actions",
        markAsProcessing: "Mark as Processing",
        markAsShipped: "Mark as Shipped",
        markAsDelivered: "Mark as Delivered",
        selected: "selected",

        // Search and filters
        searchOrders: "Search orders or customers...",
        allStatus: "All Status",
        pending: "Pending",
        processing: "Processing",
        confirmed: "Confirmed",
        shipped: "Shipped",
        delivered: "Delivered",
        cancelled: "Cancelled",
        refunded: "Refunded",

        // Table headers
        orderId: "Order ID",
        orderNumber: "Order Number",
        customer: "Customer",
        date: "Date",
        status: "Status",
        total: "Total",
        payment: "Payment",
        actions: "Actions",

        // Customer info
        guest: "Guest",

        // Payment methods
        cashOnDelivery: "Cash on Delivery",
        creditCard: "Credit Card",
        hostedCheckout: "Online Payment",
        directBankTransfer: "Bank Transfer",
        paypal: "PayPal",
        applePay: "Apple Pay",

        // Actions
        view: "View",
        invoice: "Invoice",

        // Empty states
        noOrdersFound: "No orders found. Try adjusting your filters.",

        // Loading states
        loadingOrders: "Loading orders...",
        loadingMoreOrders: "Loading more orders...",

        // Pagination
        loadMoreOrders: "Load More Orders",

        // Bulk action messages
        selectAtLeastOneOrder: "Please select at least one order.",
        successfullyUpdatedOrders: "Successfully updated {count} orders to {status}",
        failedToUpdateOrders: "Updated {successCount} orders, but failed to update {failedCount} orders.",
        failedToUpdateAllOrders: "Failed to update all {failedCount} orders. See console for details.",
        invalidActionSelected: "Invalid action selected",
        permissionCheckFailed: "Permission check failed: {message}",
        failedToUpdateOrderStatus: "Failed to update order status: {message}",

        // Error messages
        failedToLoadOrders: "Failed to load orders. Please try again.",
        failedToLoadMoreOrders: "Failed to load more orders. Please try again.",

        // Date formatting
        dateNotAvailable: "N/A",

        // Payment formatting
        paymentNotAvailable: "N/A",
        transactionNumber: "Transaction #{id}...",

        // Status colors and labels
        statusPending: "Pending",
        statusProcessing: "Processing",
        statusConfirmed: "Confirmed",
        statusShipped: "Shipped",
        statusDelivered: "Delivered",
        statusCancelled: "Cancelled",
        statusRefunded: "Refunded",

        // Order Details View
        orderDetails: "Order Details",
        orderNotFound: "Order not found",
        backToOrders: "Back to Orders",
        updateStatus: "Update Status",
        sendNotification: "Send Notification",
        updating: "Updating...",
        orderStatusUpdated: "Order status updated successfully",
        failedToLoadOrderDetails: "Failed to load order details. Please try again.",
        failedToUpdateStatus: "Failed to update order status. Please try again.",
        loading: "Loading...",

        // Order Info Sections
        orderInformation: "Order Information",
        customerInformation: "Customer Information",
        shippingInformation: "Shipping Information",
        orderItems: "Order Items",

        // Order Info Fields
        orderNumber: "Order Number",
        orderDate: "Order Date",
        orderStatus: "Order Status",
        paymentMethod: "Payment Method",
        paymentStatus: "Payment Status",
        paymentReceipt: "Payment Receipt",
        viewReceipt: "View Receipt",
        totalAmount: "Total Amount",
        subtotal: "Subtotal",
        shippingCost: "Shipping Cost",
        tax: "Tax",
        discount: "Discount",

        // Customer Info Fields
        customerName: "Customer Name",
        customerEmail: "Customer Email",
        customerPhone: "Customer Phone",

        // Shipping Info Fields
        shippingAddress: "Shipping Address",
        billingAddress: "Billing Address",
        shippingMethod: "Shipping Method",
        trackingNumber: "Tracking Number",

        // Order Items Table
        item: "Item",
        quantity: "Quantity",
        price: "Price",
        totalPrice: "Total",
        product: "Product",
        variant: "Variant",
        sku: "SKU",

        // Status Update Section
        currentStatus: "Current Status",
        newStatus: "New Status",
        selectNewStatus: "Select new status",
        statusUpdateNotes: "Notes (optional)",
        addNotesForStatusUpdate: "Add notes for this status update...",
        updateOrderStatus: "Update Order Status",
        cancel: "Cancel",

        // Common
        yes: "Yes",
        no: "No",
        save: "Save",
        close: "Close",
        confirm: "Confirm",
        edit: "Edit",

        // Invoice
        invoice: "Invoice",
        invoiceNumber: "Invoice Number",
        printInvoice: "Print Invoice",
        downloadInvoice: "Download Invoice",
        backToOrderDetails: "Back to Order Details",
        orderInvoice: "Order Invoice",
        billTo: "Bill To",
        shipTo: "Ship To",
        orderSummary: "Order Summary",
        itemDescription: "Item Description",
        unitPrice: "Unit Price",
        qty: "Qty",
        amount: "Amount",
        grandTotal: "Grand Total",
        paymentInfo: "Payment Information",
        orderNotes: "Order Notes",
        thanksForOrder: "Thank you for your order!",
        companyInfo: "Company Information",
        invoiceDate: "Invoice Date",
        dueDate: "Due Date",
        terms: "Terms"
    },
    ar: {
        // Page header
        orders: "الطلبات",
        viewAndManageOrders: "عرض وإدارة طلبات العملاء",

        // Action buttons
        bulkActions: "إجراءات مجمعة",
        markAsProcessing: "تحديد كقيد المعالجة",
        markAsShipped: "تحديد كمرسل",
        markAsDelivered: "تحديد كمُسلم",
        selected: "محدد",

        // Search and filters
        searchOrders: "البحث في الطلبات أو العملاء...",
        allStatus: "جميع الحالات",
        pending: "معلق",
        processing: "قيد المعالجة",
        confirmed: "مؤكد",
        shipped: "مرسل",
        delivered: "مُسلم",
        cancelled: "ملغي",
        refunded: "مسترد",

        // Table headers
        orderId: "رقم الطلب",
        orderNumber: "رقم الطلب",
        customer: "العميل",
        date: "التاريخ",
        status: "الحالة",
        total: "المجموع",
        payment: "الدفع",
        actions: "الإجراءات",

        // Customer info
        guest: "ضيف",

        // Payment methods
        cashOnDelivery: "الدفع عند التسليم",
        creditCard: "بطاقة ائتمان",
        hostedCheckout: "الدفع الإلكتروني",
        directBankTransfer: "التحويل البنكي",
        paypal: "باي بال",
        applePay: "آبل باي",

        // Actions
        view: "عرض",
        invoice: "فاتورة",

        // Empty states
        noOrdersFound: "لم يتم العثور على طلبات. جرب تعديل المرشحات.",

        // Loading states
        loadingOrders: "جارٍ تحميل الطلبات...",
        loadingMoreOrders: "جارٍ تحميل المزيد من الطلبات...",

        // Pagination
        loadMoreOrders: "تحميل المزيد من الطلبات",

        // Bulk action messages
        selectAtLeastOneOrder: "يرجى تحديد طلب واحد على الأقل.",
        successfullyUpdatedOrders: "تم تحديث {count} طلبات بنجاح إلى {status}",
        failedToUpdateOrders: "تم تحديث {successCount} طلبات، لكن فشل في تحديث {failedCount} طلبات.",
        failedToUpdateAllOrders: "فشل في تحديث جميع الطلبات {failedCount}. راجع وحدة التحكم للتفاصيل.",
        invalidActionSelected: "تم تحديد إجراء غير صالح",
        permissionCheckFailed: "فشل فحص الأذونات: {message}",
        failedToUpdateOrderStatus: "فشل في تحديث حالة الطلب: {message}",

        // Error messages
        failedToLoadOrders: "فشل في تحميل الطلبات. يرجى المحاولة مرة أخرى.",
        failedToLoadMoreOrders: "فشل في تحميل المزيد من الطلبات. يرجى المحاولة مرة أخرى.",

        // Date formatting
        dateNotAvailable: "غير متوفر",

        // Payment formatting
        paymentNotAvailable: "غير متوفر",
        transactionNumber: "معاملة رقم {id}...",

        // Status colors and labels
        statusPending: "معلق",
        statusProcessing: "قيد المعالجة",
        statusConfirmed: "مؤكد",
        statusShipped: "مرسل",
        statusDelivered: "مُسلم",
        statusCancelled: "ملغي",
        statusRefunded: "مسترد",

        // Order Details View
        orderDetails: "تفاصيل الطلب",
        orderNotFound: "الطلب غير موجود",
        backToOrders: "العودة للطلبات",
        updateStatus: "تحديث الحالة",
        sendNotification: "إرسال إشعار",
        updating: "جارٍ التحديث...",
        orderStatusUpdated: "تم تحديث حالة الطلب بنجاح",
        failedToLoadOrderDetails: "فشل في تحميل تفاصيل الطلب. يرجى المحاولة مرة أخرى.",
        failedToUpdateStatus: "فشل في تحديث حالة الطلب. يرجى المحاولة مرة أخرى.",
        loading: "جارٍ التحميل...",

        // Order Info Sections
        orderInformation: "معلومات الطلب",
        customerInformation: "معلومات العميل",
        shippingInformation: "معلومات الشحن",
        orderItems: "عناصر الطلب",

        // Order Info Fields
        orderNumber: "رقم الطلب",
        orderDate: "تاريخ الطلب",
        orderStatus: "حالة الطلب",
        paymentMethod: "طريقة الدفع",
        paymentStatus: "حالة الدفع",
        paymentReceipt: "إيصال الدفع",
        viewReceipt: "عرض الإيصال",
        totalAmount: "المبلغ الإجمالي",
        subtotal: "المجموع الفرعي",
        shippingCost: "تكلفة الشحن",
        tax: "الضريبة",
        discount: "الخصم",

        // Customer Info Fields
        customerName: "اسم العميل",
        customerEmail: "بريد العميل الإلكتروني",
        customerPhone: "هاتف العميل",

        // Shipping Info Fields
        shippingAddress: "عنوان الشحن",
        billingAddress: "عنوان الفوترة",
        shippingMethod: "طريقة الشحن",
        trackingNumber: "رقم التتبع",

        // Order Items Table
        item: "العنصر",
        quantity: "الكمية",
        price: "السعر",
        totalPrice: "المجموع",
        product: "المنتج",
        variant: "المتغير",
        sku: "رمز المنتج",

        // Status Update Section
        currentStatus: "الحالة الحالية",
        newStatus: "الحالة الجديدة",
        selectNewStatus: "اختر الحالة الجديدة",
        statusUpdateNotes: "ملاحظات (اختياري)",
        addNotesForStatusUpdate: "أضف ملاحظات لتحديث الحالة...",
        updateOrderStatus: "تحديث حالة الطلب",
        cancel: "إلغاء",

        // Common
        yes: "نعم",
        no: "لا",
        save: "حفظ",
        close: "إغلاق",
        confirm: "تأكيد",
        edit: "تعديل",

        // Invoice
        invoice: "فاتورة",
        invoiceNumber: "رقم الفاتورة",
        printInvoice: "طباعة الفاتورة",
        downloadInvoice: "تحميل الفاتورة",
        backToOrderDetails: "العودة لتفاصيل الطلب",
        orderInvoice: "فاتورة الطلب",
        billTo: "فاتورة إلى",
        shipTo: "شحن إلى",
        orderSummary: "ملخص الطلب",
        itemDescription: "وصف المنتج",
        unitPrice: "سعر الوحدة",
        qty: "الكمية",
        amount: "المبلغ",
        grandTotal: "المجموع الكلي",
        paymentInfo: "معلومات الدفع",
        orderNotes: "ملاحظات الطلب",
        thanksForOrder: "شكراً لك على طلبك!",
        companyInfo: "معلومات الشركة",
        invoiceDate: "تاريخ الفاتورة",
        dueDate: "تاريخ الاستحقاق",
        terms: "الشروط"
    }
};

// Translation hook for admin orders
export const useAdminOrdersTranslation = (language = 'en') => {
    const t = (key, replacements = {}) => {
        let translation = adminOrdersTranslations[language]?.[key] || adminOrdersTranslations['en'][key] || key;

        // Handle string replacements like {count}, {status}, {message}
        Object.keys(replacements).forEach(placeholder => {
            translation = translation.replace(new RegExp(`{${placeholder}}`, 'g'), replacements[placeholder]);
        });

        return translation;
    };

    return { t };
};